import type { IAskCitation } from "../../lib/types/ask"

/**
 * Split an assistant answer into its verdict (the first paragraph — the backend
 * prompt makes this a single plain-language sentence answering the question) and
 * the supporting body. The split is the first blank line; when there is none the
 * whole answer is the verdict and the body is empty (a one-line answer is all
 * verdict). Robust to `\r\n` and leading/trailing whitespace.
 */
export function splitVerdict(content: string): { verdict: string; body: string } {
  const normalized = content.replace(/\r\n/g, "\n").trim()
  const blank = normalized.match(/\n[ \t]*\n/)
  if (!blank || blank.index === undefined) return { verdict: normalized, body: "" }
  return {
    verdict: normalized.slice(0, blank.index).trim(),
    body: normalized.slice(blank.index + blank[0].length).trim(),
  }
}

/** Count of distinct source meetings across an answer's citations — powers the
 * "Answered from N meeting(s)" footnote (the model id is no longer surfaced). */
export function distinctMeetingCount(citations: IAskCitation[] | null | undefined): number {
  if (!citations || citations.length === 0) return 0
  const ids = new Set<string>()
  for (const citation of citations) ids.add(citation.meetingId)
  return ids.size
}
